var OVERLAY_POSITIONS = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  BOTTOM: 'BOTTOM',
  TOP: 'TOP',
  CENTERED_VERTICALLY: 'CENTERED_VERTICALLY',
  CENTERED_HORIZONTALLY: 'CENTERED_HORIZONTALLY'
};
export default OVERLAY_POSITIONS;